// extracted by mini-css-extract-plugin
export var container = "hover-highlight-text-module--container--38PWA";
export var highlightTextFont = "hover-highlight-text-module--highlightTextFont--2YTAI";
export var normalTextFont = "hover-highlight-text-module--normalTextFont--2s0RQ";